export default __webpack_public_path__ + "static/ultherapy_1-f5befbc3a2001502bd7248f646965d27.jpg";